import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocale } from "@/hooks/useLocale";
import { localizedPath } from "@/i18n/languages";
import { articlesMeta } from "@/mocks/articles";

export default function GuidesSection() {
  const { t } = useTranslation();
  const lang = useLocale();

  return (
    <section id="guides" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-wide text-accent-600">
            {t("guides.eyebrow")}
          </span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
            {t("guides.title")}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            {t("guides.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articlesMeta.map((article) => (
            <Link
              key={article.slug}
              to={localizedPath(lang, `/${article.slug}`)}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform hover:-translate-y-1"
            >
              <div className="aspect-[16/10] w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={t(`art.${article.slug}.title`)}
                  title={t(`art.${article.slug}.title`)}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between gap-2">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className={`${article.icon} text-sm`} />
                    </span>
                    {t(`art.${article.slug}.badge`)}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-foreground-950">
                  {t(`art.${article.slug}.title`)}
                </h3>
                <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">
                  {t(`art.${article.slug}.excerpt`)}
                </p>
                <span className="mt-4 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-600">
                  {t("guides.readMore")}
                  <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-1">
                    <i className="ri-arrow-right-line text-base" />
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}